module.exports = __webpack_public_path__ + "static/media/CZ.b5329781.svg";